import React from "react";
import AppRouter from "./application/config/router";
import { AntdConfig } from "./application/config/antd.config";

export function Application() {
  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <AntdConfig>
        <AppRouter />
      </AntdConfig>
    </div>
  );
}